/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  OTELAttributeValue,
  OTELAttributeValue$Outbound,
  OTELAttributeValue$outboundSchema,
} from "./otelattributevalue.js";

/**
 * OTEL resource attribute
 */
export type OTELResourceAttribute = {
  /**
   * Resource attribute key
   */
  key: string;
  /**
   * OTEL attribute value - any of the OTLP/JSON value kinds
   */
  value?: OTELAttributeValue | undefined;
};

/** @internal */
export type OTELResourceAttribute$Outbound = {
  key: string;
  value?: OTELAttributeValue$Outbound | undefined;
};

/** @internal */
export const OTELResourceAttribute$outboundSchema: z.ZodMiniType<
  OTELResourceAttribute$Outbound,
  OTELResourceAttribute
> = z.object({
  key: z.string(),
  value: z.optional(OTELAttributeValue$outboundSchema),
});

export function otelResourceAttributeToJSON(
  otelResourceAttribute: OTELResourceAttribute,
): string {
  return JSON.stringify(
    OTELResourceAttribute$outboundSchema.parse(otelResourceAttribute),
  );
}
